import { toast } from "sonner";

/**
 * Shared doctor-label printer. Opens a 60mm x 40mm label sheet in a new
 * window and triggers the browser print dialog. Used by the referring
 * doctors page and the referral To/Reply forms.
 */
export interface LabelData {
  name: string;
  designation?: string | null;
  clinicHospital?: string | null;
  address?: string | null;
}

export function printDoctorLabel(d: LabelData) {
  const w = window.open("", "_blank", "width=400,height=300");
  if (!w) {
    toast.error("Pop-up blocked — allow pop-ups to print labels.");
    return;
  }
  w.document.write(`<!doctype html><html><head><title>Label — ${d.name}</title>
<style>
@page { size: 60mm 40mm; margin: 2mm; }
body { font-family: Arial, sans-serif; font-size: 9pt; margin: 0; padding: 2mm; }
.name { font-weight: bold; font-size: 11pt; }
.spec { font-style: italic; color: #444; }
.clinic { margin-top: 1mm; }
.addr { margin-top: 1mm; font-size: 8pt; color: #666; }
</style></head><body>
<div class="name">${d.name}</div>
${d.designation ? `<div class="spec">${d.designation}</div>` : ""}
${d.clinicHospital ? `<div class="clinic">${d.clinicHospital}</div>` : ""}
${d.address ? `<div class="addr">${d.address}</div>` : ""}
</body></html>`);
  w.document.close();
  w.focus();
  setTimeout(() => {
    w.print();
    w.close();
  }, 250);
}
